import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import colors from 'components/utils/colors'

const StyledSection = styled.section`
  padding: 12px 5px 24px 17px;
  border-bottom: 1px solid ${colors.secondary70};
  h4 {
    padding-bottom: 14px !important;
    font-size: 10px;
    color: ${colors.secondary40};
  }
  ${props => props.isCheckbox && styleAsCheckbox}
  ${props => props.withoutBorder && styledAsWithoutBorder}
  ${props => props.active && styledAsActive}
`

const styledAsWithoutBorder = css`
  border-bottom: 0;
`

const styledAsActive = css`
  h4 {
    color: #000;
  }
`

const styleAsCheckbox = css`
  display: flex;
  padding: 12px 17px 12px 17px;
  height: 16px;
  h4 {
    flex: 1;
    padding-bottom: 0px;
    display: flex;
    font-size: 14px !important;
  }
`

const SidebarFilterSection = ({ children, active, title, isCheckbox, withoutBorder }) => {
  return (
    <StyledSection active={active} isCheckbox={isCheckbox} withoutBorder={withoutBorder}>
      {children}
      <h4>{title}</h4>
    </StyledSection>
  )
}

SidebarFilterSection.propTypes = {
  children: PropTypes.node,
  active: PropTypes.bool,
  title: PropTypes.string,
  isCheckbox: PropTypes.bool,
  withoutBorder: PropTypes.bool,
}

export default SidebarFilterSection
